module.exports = __webpack_public_path__ + "img/predinein.26a6d908.svg";